module.exports = {
      id: "icon-play-usage",
      viewBox: "0 0 17.037 21.916",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }